import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DESAFIO_EQUIPO } from '@env';

@Injectable()
export class DesafioEquipoProvider {

  // private headers: HttpHeaders;

  constructor(public http: HttpClient) {
    // this.headers = new HttpHeaders({ 'HiddenLoading': 'yes'});
  }

  estatus(area: string, equipo: string, jugador: string): Promise<any> {
    return this.http.get( `${DESAFIO_EQUIPO.ESTATUS}${area}/${equipo}/${jugador}` ).toPromise();
  }

  siguienteRonda(area: string, equipo: string, jugador: string): Promise<any> {
    return this.http.get( `${DESAFIO_EQUIPO.SIGUIENTE_RONDA}${area}/${equipo}/${jugador}` ).toPromise();
  }

  tablero(area: string, equipo: string, jugador: string): Promise<any> {
    return this.http.get( `${DESAFIO_EQUIPO.TABLERO}${area}/${equipo}/${jugador}` ).toPromise();
  }

  guardaRonda(area: string, equipo: string, jugador: string, ronda: any): Promise<any> {
    return this.http.post( `${DESAFIO_EQUIPO.GUARDA_ESTADISTICA}${area}/${equipo}/${jugador}`, ronda ).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/providers/desafio-equipo/desafio-equipo.ts